"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionApiCommand = void 0;
class ConversionApiCommand {
    constructor(input) {
        this.input = input;
    }
    async execute() {
        const META_EVENT_URL = `${process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? 'https://www.kidsplaza.vn'}/api/event/meta-conversion-api`;
        try {
            await fetch(META_EVENT_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(this.input),
            });
        }
        catch (error) {
            console.log('ERROR: ', error);
        }
    }
}
exports.ConversionApiCommand = ConversionApiCommand;
